module.exports = __webpack_public_path__ + "c1917be9890053d3165c63b55e277aa3.png";